import { useState } from 'react'
import { useUpdateProject, useUsers } from '../api/queries'
import type { Project } from '../api/types'

/**
 * Sagens projektleder - og et skift af den (beslutning 084).
 *
 * Kan rettes af Superadmin, Administrator og Projektleder på alle sager, præcis
 * som serveren tillader (beslutning 066). Skiftet står i aktivitetsloggen.
 */
export function ProjectManagerControl({ project, canEdit }: { project: Project; canEdit: boolean }) {
  const update = useUpdateProject(project.id)
  const { data: users } = useUsers()
  const [editing, setEditing] = useState(false)
  const [value, setValue] = useState('')
  const [error, setError] = useState<string | null>(null)

  function start() {
    setValue(project.projectManager ? String(project.projectManager.id) : '0')
    setError(null)
    setEditing(true)
  }

  async function save(event: React.FormEvent) {
    event.preventDefault()
    setError(null)

    try {
      // 0 = ingen projektleder. Serveren læser null som "lad stå".
      await update.mutateAsync({ projectManagerId: Number(value) })
      setEditing(false)
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Projektlederen kunne ikke skiftes.')
    }
  }

  return (
    <div>
      <div className="tiny muted">Projektleder</div>
      {editing ? (
        <form className="row" style={{ gap: 6, flexWrap: 'wrap' }} onSubmit={(e) => void save(e)}>
          <select
            aria-label="Projektleder"
            autoFocus
            value={value}
            onChange={(e) => setValue(e.target.value)}
            style={{ width: 'auto', maxWidth: 220 }}
          >
            <option value="0">Ingen projektleder</option>
            {users?.map((user) => (
              <option key={user.id} value={user.id}>
                {user.displayName}
              </option>
            ))}
          </select>
          <button className="btn btn--primary btn--sm" type="submit" disabled={update.isPending}>
            {update.isPending ? 'Gemmer ...' : 'Gem'}
          </button>
          <button className="btn btn--sm" type="button" onClick={() => setEditing(false)}>
            Fortryd
          </button>
          {error && <span className="tiny warn">{error}</span>}
        </form>
      ) : (
        <div className="row small" style={{ gap: 8, flexWrap: 'wrap' }}>
          <span>{project.projectManager?.displayName ?? '-'}</span>
          {canEdit && (
            <button className="btn btn--sm" type="button" onClick={start}>
              Skift
            </button>
          )}
        </div>
      )}
    </div>
  )
}
